import axios from "../../lib/axios"

import {
  GetActiveGiftCreditRequestService,
  GetClosedGiftCreditRequestService,
  GetGiftAllowedFacilityInstallmentCountsService,
  GetGiftCreditRequestFlowService,
  GetGiftCreditSaveVideoService,
  UpdateGiftCreditUserInfoService
} from "./types"

const BASE_URL = "/api/v1/giftCredit"

export const getGiftCreditRequestFlow: GetGiftCreditRequestFlowService = params => {
  return axios.get(`${BASE_URL}/getGiftCreditRequestFlow`, params)
}

export const getActiveGiftCreditRequests: GetActiveGiftCreditRequestService = () => {
  return axios.get(`${BASE_URL}/getActiveGiftCreditRequests`)
}

export const getClosedGiftCreditRequests: GetClosedGiftCreditRequestService = () => {
  return axios.get(`${BASE_URL}/getClosedGiftCreditRequests`)
}

export const getGiftCreditUserInfo = () => {
  return axios.get(`${BASE_URL}/getUserInfo`)
}

export const updateGiftCreditUserInfo: UpdateGiftCreditUserInfoService = ({ payload }) => {
  return axios.put(`${BASE_URL}/updateUserInfo`, payload)
}

export const inquiryGiftCreditPostalCode = params => {
  return axios.get(`${BASE_URL}/inquiryPostalCode`, params)
}

export const inquiryGiftCreditUserCard = params => {
  return axios.get(`${BASE_URL}/inquiryUserCard`, params)
}

const getContractPreview = params => {
  return axios.get(`${BASE_URL}/getContractPreview`, params)
}

const signContract = ({ payload }) => {
  return axios.post(`${BASE_URL}/signContract?facilityRequestId=${payload.facilityRequestId}`, payload)
}

const getFacilityAllowedInstallmentCounts: GetGiftAllowedFacilityInstallmentCountsService = (params) => {
  return axios.get(`${BASE_URL}/getGiftCreditAllowedFacilityInstallmentCounts`, params)
}

const getKycStatus = () => {
  return axios.get("/api/v1/kyc/giftCredi_IsVerifyEkyc")
}

const saveSelfieVideo: GetGiftCreditSaveVideoService = ({ payload }) => {
  return axios.post("/api/v1/kyc/giftCredit_SaveSelfieVideo", payload)
}

const giftCreditServices = {
  getGiftCreditRequestFlow,
  getActiveGiftCreditRequests,
  getClosedGiftCreditRequests,
  getGiftCreditUserInfo,
  inquiryGiftCreditUserCard,
  updateGiftCreditUserInfo,
  inquiryGiftCreditPostalCode,
  getContractPreview,
  signContract,
  getFacilityAllowedInstallmentCounts,
  getKycStatus,
  saveSelfieVideo
}

export default giftCreditServices
